/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m15.0618 14.9975.0017.0101c.3602 2.1246 2.2094 3.7424 4.4365 3.7424 2.4853 0 4.5-2.0147 4.5-4.5s-2.0147-4.5-4.5-4.5c-2.1746 0-3.989 1.5425-4.4086 3.5931a4.5693 4.5693 0 0 0-.0279.1493l-.0017.0101A.744.744 0 0 0 15 13.5h-3.75v-3c0-.8284-.6716-1.5-1.5-1.5h-3V6H9c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3H3C1.3432 0 0 1.3432 0 3c0 1.6569 1.3432 3 3 3h2.25v3h-3c-.8284 0-1.5.6716-1.5 1.5V18c0 .8284.6716 1.5 1.5 1.5h3v3.75a.75.75 0 0 0 1.5 0V19.5h3c.8284 0 1.5-.6716 1.5-1.5v-3H15a.744.744 0 0 0 .0618-.0025ZM3 1.5c-.8284 0-1.5.6716-1.5 1.5S2.1716 4.5 3 4.5h6c.8284 0 1.5-.6716 1.5-1.5S9.8284 1.5 9 1.5H3Zm19.5 12.75c0-1.6569-1.3431-3-3-3s-3 1.3431-3 3 1.3431 3 3 3 3-1.3431 3-3ZM9.75 10.5V18h-7.5v-7.5h7.5Z"
    clipRule="evenodd"
  />,
  'Diagram'
);
